import "./scss/index.scss";

import { skalert } from "./alert";
import { loading, SkLoading } from "./loading";
import { URLS } from "fire-wind-water";
import {
  Checkbox,
  Desc,
  Field,
  File,
  updateDirty,
  Line,
  List,
  Policy,
  CustomPolicy,
  Select,
  Text,
  DateTime,
  Radio,
  CheckboxSelect,
  Cascader,
} from "./field";
import { sktips } from "./tips";
import { ck, cr } from "fire-wind-water";
import { config } from "./conf/settings";
import { sxhr, sxhrRequest, sxhrHeaders } from "fire-wind-water/sxhr";
import { JsonObject } from "./interface/json";
import { $get, $httpGet, $skxhr, $skxhrp, $upload } from "./services";
import { getChannelParams } from "./core/channel";
import { removeSearchParam } from "fire-wind-water/url/url";
import countryCode from "./core/countryCode";

export const setApiUrl = cr.noop;
export const setUploadUrl = cr.noop;

ck.json = true;
sxhrRequest(
  <T>(config: JsonObject): T => {
    if (config.method === "post" || config.method === "POST") {
      //增加来源渠道参数
      const browseChannel = getChannelParams();
      // console.log("getBrowseChannel_sk = " + JSON.stringify(browseChannel));
      cr.extend(true, config.data, {
        browseInfo: browseChannel,
        globalUserId: ck.cookie("globalUserId"),
      });
    }
    if (
      config.url.includes("/member/login") ||
      config.url.includes("/member/register")
    ) {
      let m = ck.cookie("miniMipToken");
      if (m) {
        m = m.replace("bearer ", "");
        cr.extend(true, config.data, { miniMipToken: m || null });
      }
    }

    return config as T;
  },
  (err) => {
    console.log(err);
  }
);
sxhrHeaders("Content-Type", "text/plain");

const $sk: any = {
  alert(html: string, conf: { [label: string]: any }): void {
    skalert.show(html, conf, 0);
  },
  confirm(html: string, conf: { [label: string]: any }): void {
    skalert.show(html, conf, 1);
  },
  loading: loading,
  inlineLoading() {
    return new SkLoading();
  },
  tips: sktips,
  Checkbox,
  Desc,
  Field,
  File,
  updateDirty,
  Line,
  List,
  Policy,
  CustomPolicy,
  Select,
  Text,
  DateTime,
  Radio,
  CheckboxSelect,
  Cascader,
  setApiUrl,
  setUploadUrl,
  sxhrRequest,
  sxhrHeaders,
  sxhr,
};

const link = document.createElement("link");
link.rel = "stylesheet"; // 指定这是一个样式表
link.href = config.cdn + "/ckeditor/assets/temp.css";

document.head.appendChild(link);

function addCkCntent() {
  const dom = document.querySelector(".ck-content");
  const editorDom =
    document.querySelector(".m-pc-content") ||
    document.querySelector(".m-wap-content") ||
    document.querySelector(".g-info-content");
  if (!dom) {
    if (editorDom) {
      editorDom.className = editorDom.className + " ck-content";
    } else {
      setTimeout(() => {
        addCkCntent();
      }, 100);
    }
  }
}

window.addEventListener(
  "load",
  () => {
    addCkCntent();
  },
  false
);

$sk.$skxhr = $skxhr;
$sk.$skxhrp = $skxhrp;
$sk.$upload = $upload;
$sk.$xhrget = $httpGet;
$sk.$xhrgetp = $get;
$sk.formatInternationalPhone = countryCode.formatInternationalPhone;
$sk.config = config;
//如果锚点之后有全员营销、渠道的参数要追加进来
const arr = ["markCode", "marketingTaskId", "track_id"];
let urlstr = window.location.href;
let isadd = false;
arr.forEach((d) => {
  const value = URLS.getHash(d);
  if (value) {
    isadd = true;
    let zurl = urlstr.replace(d + "=" + value, "");
    zurl = zurl.replace("&&", "");
    urlstr = URLS.updateSearchParam(d, value, zurl);
  }
});
if (isadd) {
  window.location.href = urlstr;
}
export { $sk };
